import Image from 'next/image';
import Link from 'next/link';
import { ArrowRightCircle } from 'lucide-react';
import TimelineSidebar from '@/components/PartnerPortal/TimelineSidebarPartner';

const tiers = [
  {
    level: 'CERTIFIED',
    color: 'text-[#00AEEF]',
    border: 'border-[#00AEEF]',
    bg: '/background-certified-platinum logo.svg', // Replace with actual path
    title:
      'A Certified PSP is the first level of achievement for a partner provider consulting, implementation and support services for Simplicity® solution.',
    requirements: [
      'Minimum 1 Simplicity® Certified Low Code Development Platform (LCDP) Developer.',
      'Certified Service Provider Program Agreement.',
    ],
  },
  {
    level: 'SILVER',
    color: 'text-[#B2B2B2]',
    border: 'border-[#B2B2B2]',
    bg: '/background-certified-silver logo.svg',
    title:
      'Silver Certified PSPs have invested significant training for their team, who are led by experienced and proficient staff.',
    requirements: [
      'Minimum 1 Simplicity® Certified LCDP Developer, at least 2 or more of whom have at least 2 years of Simplicity® LCDP experience.',
      'Minimum 1 Simplicity® Certified Functional Consultant.',
      'Silver Certified Service Provider Program Agreement.',
    ],
  },
  {
    level: 'GOLD',
    color: 'text-[#FFB800]',
    border: 'border-[#FFB800]',
    bg: '/background-certified-gold logo.svg',
    title:
      'Gold Certified PSPs have attained the highest level of qualification and employ in-depth technical and functional talent who can deliver projects of highest complexity.',
    requirements: [
      'Minimum 10 Simplicity® Certified LCDP Developers...',
      'Minimum 3 Simplicity® Certified Functional Consultants...',
      'Gold Certified Service Provider Program Agreement.',
    ],
  },
];

export default function CertificationTiers() {
  return (
    <section
      className="max-w-8xl mx-auto flex flex-col lg:flex-row justify-center gap-x-8 bg-[#373737]"
      style={{ scrollMarginTop: '150px' }}
    >
      <div className="w-full lg:w-6/12 relative">
        <div className="col-span-12 xl:col-span-5 pb-16">
          <div className="p-10">
            <h1 className="mb-10 text-6xl text-[#BF984D] whitespace-pre-line">
              {'Professional\n Services\n Providers'}
            </h1>
            <span className="text-white block text-lg tracking-wider whitespace-pre-line">
              {
                'Professional Services Providers are classified\n into 3 tiers depending on their pool and depth\n of technical and functional expertise.'
              }
            </span>
            <Link
              href="https://anacle.com/contact-us/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="mt-4 md:mt-6 text-base md:text-lg font-semibold w-full sm:w-8/12 md:w-7/12 h-[45px] flex justify-between items-center px-4 border border-[#BF984D] text-[#BF984D]">
                <span>Get Certified</span>
                <ArrowRightCircle size="26" />
              </button>
            </Link>
          </div>
          <div className="relative mt-16 grid grid-cols-12 w-full lg:h-[938px]">
            <div className="col-span-5 ml-11 mt-20">
              <TimelineSidebar selectedIndex={5} colorText="#fff" />
            </div>
            <Image
              src={'/background-professional services providers.svg'}
              alt={'Feature image'}
              className="h-full object-cover w-auto col-span-7 hidden lg:block"
              width={550}
              height={938}
              priority
            />
          </div>
        </div>
      </div>
      <div className="w-full lg:w-6/12 relative">
        <div className="px-6 py-8 sm:pr-6 sm:py-14 grid grid-cols-1 gap-6 sm:gap-8 text-white">
          {tiers.map((tier) => (
            <div
              key={tier.level}
              id={tier.level}
              className="relative flex flex-col sm:flex-row items-start min-h-[300px] sm:min-h-[428px] border border-[#A09D9D] text-sm"
            >
              {/* Left vertical border */}
              <div className="w-full sm:w-8 h-2 sm:h-full border-r border-[#A09D9D] sm:border-t-0 border-t sm:border-r" />

              {/* Main content */}
              <div className="relative w-full flex flex-col px-4 sm:px-0">
                {/* Title stays at top */}
                <p className="absolute top-4 sm:top-6 left-4 sm:left-6 text-xs sm:text-sm text-white max-w-full sm:max-w-[50%] leading-relaxed z-10 whitespace-pre-line">
                  {tier.title}
                </p>

                {/* Background building image */}
                <div className="relative w-full h-[180px] sm:h-[220px] mt-12 sm:mt-8">
                  <Image
                    src={tier.bg}
                    alt="Background"
                    layout="fill"
                    objectFit="contain"
                    className="pointer-events-none"
                  />
                </div>

                {/* Requirements */}
                <span className="px-4 sm:px-8 pt-4 sm:pt-5 pb-2 text-xs sm:text-sm">
                  Requirements:
                </span>
                <div className="pl-6 sm:pl-14 pb-4 sm:pb-6 mt-auto z-10 mb-4 sm:mb-7">
                  <ul className="list-inside custom-circle text-xs sm:text-sm space-y-2 text-white">
                    {tier.requirements.map((req, i) => (
                      <li key={i}>{req}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
